import { visionLabApi } from '@/app/apiClient';
import type { RelayReply } from '../types/uploadRelay';

export function requestUploadRelayTicket(
  sessionId: string,
  signal?: AbortSignal,
  previousTicket?: string,
  frameCount?: number,
): Promise<RelayReply> {
  return visionLabApi.post<RelayReply>(
    `/submissions/${encodeURIComponent(sessionId)}/relay-ticket`,
    {
      signal,
      json: {
        route: 'china',
        ...(previousTicket ? { previousTicket } : {}),
        ...(frameCount === undefined ? {} : { frameCount }),
      },
    },
  );
}
